import React, { FC, FormEvent } from 'react'
import { Input } from 'shared/components/Input'
import { Button } from 'shared/components/Button'
import { Icon } from 'shared/components/Icons'
import { StyledNomenclatureDiscountInputContainer } from './styles'

interface DiscountInputContainer {
    isShowPriceInput?: boolean
    price?: number | null
    absolutDiscount: number | string | null
    percentDiscount: number | string | null
    onPriceChange?: (value: FormEvent) => void
    onAbsolutDiscountChange: (value: FormEvent) => void
    onPercentDiscountChange: (value: FormEvent) => void
    onAdd?: () => void
    disabledAddButton?: boolean
    disabled?: boolean
}

export const DiscountInputContainer: FC<DiscountInputContainer> = ({
    isShowPriceInput = false,
    price,
    absolutDiscount,
    percentDiscount,
    onPriceChange,
    onAbsolutDiscountChange,
    onPercentDiscountChange,
    disabledAddButton,
    onAdd,
    disabled,
}) => {
    return (
        <StyledNomenclatureDiscountInputContainer>
            {isShowPriceInput && (
                <Input
                    name='price'
                    placeholder='0'
                    value={price ?? ''}
                    onChange={onPriceChange}
                    label='Цена, ₽'
                    disabled={disabled}
                />
            )}
            <Input
                name='absolutDiscount'
                placeholder='0'
                value={absolutDiscount ?? ''}
                onChange={onAbsolutDiscountChange}
                label='Скидка, ₽'
                disabled={disabled}
            />
            <Input
                name='percentDiscount'
                placeholder='0'
                value={percentDiscount ?? ''}
                onChange={onPercentDiscountChange}
                label='Скидка, %'
                disabled={disabled}
            />
            {onAdd && !disabled && (
                <Button
                    disabled={disabledAddButton}
                    onClick={onAdd}
                    padding={8}
                >
                    <Icon name='addRoundedIcon' />
                </Button>
            )}
        </StyledNomenclatureDiscountInputContainer>
    )
}
